// Reasons configuration for different retailers and actions

export interface ReasonConfig {
  key: string
  score?: number // Only for approve_with_reservation
}

export interface RetailerReasonsConfig {
  approve_with_reservation: ReasonConfig[]
  reject: ReasonConfig[]
  skip: ReasonConfig[]
}

// Live retailer reasons
const LIVE_REASONS: RetailerReasonsConfig = {
  approve_with_reservation: [
    { key: 'CABIDES DESALINHADOS', score: 15 },
    { key: 'FOTO NO ÂNGULO INCORRETO', score: 10 },
    { key: 'FRONTAL/BARRA SEM REPOSIÇÃO', score: 15 },
    { key: 'MATERIAL DE COMUNICAÇÃO USADO DE FORMA INCORRETA', score: 15 },
    { key: 'ORDEM DE EXPOSIÇÃO INCORRETA', score: 10 },
    { key: 'PASSADORIA (PEÇAS AMASSADAS)', score: 10 },
    { key: 'POSICIONAMENTO MANEQUINS', score: 10 },
    { key: 'TAG APARENTE', score: 15 },
  ],
  reject: [
    { key: 'A COMUNICAÇÃO DA CAMPANHA ESTÁ INCORRETA' },
    { key: 'A CONFIGURAÇÃO DAS ARARAS ESTÁ FORA DO PADRÃO' },
    { key: 'NÃO ESTÁ DE ACORDO COM A FOTO DE ORIENTAÇÃO' },
  ],
  skip: [
    { key: 'A LOJA NÃO TEM VITRINE SECUNDÁRIA' },
    { key: 'TAREFA NÃO REALIZADA POR FALTA DE ESPAÇO' },
    { key: 'NÃO REALIZADA POR FALTA DE PRODUTO / EMBARQUE' },
    { key: 'A LOJA NÃO POSSUIA CATEGORIA DE PRODUTOS KIDS' },
    { key: 'NÃO RECEBEMOS O EMBARQUE DA SEMANA' },
    { key: 'A LOJA NÃO POSSUIA CATEGORIA COMFY' },
  ],
}

// Default empty reasons for retailers without custom reasons
const DEFAULT_REASONS: RetailerReasonsConfig = {
  approve_with_reservation: [],
  reject: [],
  skip: [],
}

// Map retailer IDs to their reason configurations
export const RETAILER_REASONS_MAP: Record<string, RetailerReasonsConfig> = {
  live: LIVE_REASONS,
  stimatzky: LIVE_REASONS,
  // Add more retailers here as needed
}

// Helper function to get reasons for a specific retailer and action
export const getReasonsByRetailer = (rid: string | undefined, action: keyof RetailerReasonsConfig): ReasonConfig[] => {
  if (!rid) return DEFAULT_REASONS[action]
  return RETAILER_REASONS_MAP[rid]?.[action] || DEFAULT_REASONS[action]
}
